export default __webpack_public_path__ + "static/media/user-type-agent.7767b195.svg";